import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';

import usePostgreSmsWidgetsData from '../../../DerivedCharts/sms/hooks/usePostgreSmsWidgetData';
import { IPostgreCommunicationDTO } from '../../jobs/types/postgreJobsDTO';
import { ISmsWidgetProp } from '../../jobs/types/postgreJobsWidgetProp';
import { defaultSmsWidgetData } from '../utils/smsHelper';

const SmsStackedBarChartPostgre = ({ query, title }: ISmsWidgetProp) => {
  const { widgetData } = usePostgreSmsWidgetsData<IPostgreCommunicationDTO>(
    query,
    defaultSmsWidgetData
  );
  const categories: string[] = [];
  const sentSeries: number[] = [];
  const receivedSeries: number[] = [];
  widgetData?.response?.forEach((result) => {
    categories.push(result?.datetime ?? '');
    sentSeries.push(result?.sent ?? 0);
    receivedSeries.push(result?.received ?? 0);
  });
  const series = [
    { name: 'Sent', data: sentSeries },
    { name: 'Received', data: receivedSeries },
  ];
  const options: ApexOptions = {
    title: {
      text: title,
    },
    chart: {
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    yaxis: {
      title: { text: 'Count of Jobs Posted' },
    },
    xaxis: {
      categories: categories,
      type: 'datetime',
      title: {
        text: title,
        offsetY: 5,
      },
      labels: {
        datetimeUTC: false,
      },
    },
    stroke: {
      width: 1,
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 50,
    },
    dataLabels: {
      enabled: false,
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={series as ApexAxisChartSeries}
      type="bar"
      width="100%"
      height="100%"
    />
  );
};

export default SmsStackedBarChartPostgre;
